import { Component, OnInit, ViewChild } from '@angular/core';

import { ActivatedRoute } from '@angular/router';
import { AppInformationService, ArkUnitOfWork, AuthService, DocumentService, SessionInformationService, UtilityService } from 'app/core/core.module';
import { Agenda, Committee, CommitteeAttachment } from 'app/core/model/entity-model';
import { AttachmentDialogComponent } from 'app/executive/attachment-dialog/attachment-dialog.component';
import { EmailDialogComponent } from 'app/shared/email-dialog/email-dialog.component';
import { InputDialogComponent } from 'app/shared/input-dialog/input-dialog.component';
import { DevExtremeModule, DxDataGridComponent, DxHtmlEditorComponent } from 'devextreme-angular';
import { alert, confirm } from 'devextreme/ui/dialog';
import { environment } from 'environments/environment';
import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-committee-portal',
    templateUrl: './committee-portal.component.html',
    styleUrls: ['./committee-portal.component.scss'],
    imports: [DevExtremeModule],
    standalone: true,
})
export class CommitteePortalComponent implements OnInit {
    mode: string;

    userCommittees: any;
    agendaText: string;
    memberCode: string;
    memberEmail: string;
    memberCodeSubmit: string;
    memberEmailSubmit: string;
    selectedCommittee: any;
    selectedCommitteeId: number;
    isChair = false;
    isClerk = false;
    selectedAgenda: any;
    agendas: Agenda[] = [];
    documents: CommitteeAttachment[] = [];
    htmlChanged = false;
    userName: string;

    reviewOnly = true;
    committees: any;
    committeeId: number;
    executiveMembers: any;
    processing = false;
    serviceName = environment.serviceName;
    uploadHeaders: any;
    valueContent: any;
    agenda: any;
    items: any[] = [];
    disableSelection: boolean = false;
    suppressValueChange = false;
    canEmail: boolean = false;
    showMinutes = false;
    isAdmin = false;

    sidebarOpen = true;
    agendasOpen = true;
    documentsOpen = true;

    @ViewChild('agendaDataGrid') agendaDataGrid: DxDataGridComponent;
    @ViewChild('dataGrid') dataGrid: DxDataGridComponent;
    @ViewChild('editor') editor: DxHtmlEditorComponent;

    constructor(
        private modalService: BsModalService,
        private utility: UtilityService,
        private sessionInfo: SessionInformationService,
        private appInfo: AppInformationService,
        private uow: ArkUnitOfWork,
        private auth: AuthService,
        private docService: DocumentService,
        private route: ActivatedRoute,
    ) {}

    async ngOnInit() {
        this.mode = this.route.snapshot.data['mode'];

        if (this.mode === 'executive' || (this.auth.currentUser && this.auth.currentUser.personId)) {
            const person = await this.uow.people.byId(this.auth.currentUser.personId);
            this.memberCode = person.code;
            this.memberEmail = person.email;
            this.sessionInfo.setItem('memberCode', this.memberCode);
            this.sessionInfo.setItem('memberEmail', this.memberEmail);
        } else {
            this.memberCode = this.sessionInfo.getItem('memberCode');
            this.memberEmail = this.sessionInfo.getItem('memberEmail');
        }

        await this.utility.logRecord(this.memberEmail ?? this.auth.currentUser?.userName, 'User viewed committee page');
        if (!this.memberCode) return;

        await this.getData();
        const committeeId = this.sessionInfo.getItem('selectedCommittee', true);
        if (committeeId) {
            this.selectedCommitteeId = this.userCommittees.find((x) => x.CommitteeId === committeeId.CommitteeId)?.CommitteeId;
        }
        this.userName = this.memberEmail ?? this.auth.currentUser.userName;
        this.isAdmin = this.auth.hasRole('Administrator');
    }

    submitMemberCode() {
        this.sessionInfo.setItem('memberCode', this.memberCodeSubmit);
        this.sessionInfo.setItem('memberEmail', this.memberEmailSubmit);
        this.ngOnInit();
    }

    hasChanges() {
        return this.uow.hasChanges();
    }

    hasSelectedAgenda(): boolean {
        return (this.agendaDataGrid?.instance?.getSelectedRowsData()?.length ?? 0) > 0;
    }

    async getData() {
        this.appInfo.pleaseWaitShow();
        this.userCommittees = await this.utility.getUserCommittees(this.memberCode);
        this.appInfo.pleaseWaitHide();
    }

    async onCommitteeSelectionChanged(e) {
        if (e) this.selectedCommittee = e.selectedItem;
        else this.selectedCommittee = null;
        this.sessionInfo.setItem('selectedCommittee', this.selectedCommittee, true);
        this.setPermissions();
        await this.getAgendas();
        await this.getDocuments();
    }

    setPermissions() {
        if (!!this.selectedCommittee) {
            console.log(this.selectedCommittee);
            this.isChair = this.selectedCommittee.IsChair;
            this.isClerk = this.selectedCommittee.IsClerk || (this.selectedCommittee.CommitteeId === Committee.Committees.Finance && this.auth.hasRole('Treasurer'));
        } else {
            this.isChair = false;
            this.isClerk = false;
        }
    }

    async getAgendas() {
        if (!this.selectedCommittee) this.agendas = [];
        else this.agendas = await this.uow.getCommitteeAgendas(this.memberCode, this.selectedCommittee.CommitteeId);
    }

    async newAgenda(copy?: boolean) {
        const selectedRows = this.agendaDataGrid.instance.getSelectedRowsData();
        if (!selectedRows && copy) return;

        let name = '';
        if (!copy) {
            name = await this.getInput(`Name`, 'text', null, null);
            if (!name) return;
        } else name = selectedRows[0].name + '-Copy';

        const agenda = this.uow.agendas.createEntity({
            committeeId: this.selectedCommittee.CommitteeId,
            name: name,
            created: new Date(),
            createdBy: this.userName,
            agendaText: copy ? this.selectedAgenda.agendaText : null,
        }) as Agenda;

        await this.uow.commit();
        await this.getAgendas();
        this.selectedAgenda = agenda;
    }

    async editAgenda() {
        const selectedRows = this.agendaDataGrid.instance.getSelectedRowsData();
        if (!selectedRows) return;
        const name = await this.getInput(`Name`, 'text', null, selectedRows[0].name);
        if (name) selectedRows[0].name = name;
        await this.uow.commit();
        await this.getAgendas();
        this.appInfo.pleaseWaitHide();
    }

    async deleteAgenda() {
        const selectedRows = this.agendaDataGrid.instance.getSelectedRowsData();
        if (!selectedRows) return;
        const result = await confirm(`Are you sure you want to delete the selected Agenda?`, `GRRAFSCHAP`);
        if (!result) return;
        this.appInfo.pleaseWaitShow();
        selectedRows.forEach((row) => {
            row.deleted = new Date();
            row.deletedBy = this.userName;
        });
        await this.uow.commit();
        await this.getAgendas();
        this.appInfo.pleaseWaitHide();
    }

    async onAgendaSelectionChanged(e) {
        if (this.disableSelection) return;

        const newSelection = e.selectedRowsData[0];

        if (this.hasChanges()) {
            this.disableSelection = true;
            const result = await confirm(`There are pending changes. Continue?  Yes to lose change, No to go back and save`, `${this.appInfo.settings.church}`);
            if (!result) {
                this.agendaDataGrid.instance.selectRows(e.currentDeselectedRowKeys, false);
                this.disableSelection = false;
                return;
            }
            this.suppressValueChange = true;
            this.uow.rollback();
            this.disableSelection = false;
        }

        // Suppress the valueChange feedback loop that fires when [value] binding updates
        this.suppressValueChange = true;
        this.selectedAgenda = newSelection;
        if (this.selectedAgenda) this.agendaText = this.selectedAgenda.agendaText;
        setTimeout(() => {
            this.suppressValueChange = false;
        }, 0);
    }

    async onHtmlValueChanged(e) {
        // console.log('onHtmlValueChanged', e);
    }

    onAgendaTextChanged(value: string) {
        if (this.suppressValueChange || !this.selectedAgenda) return;
        this.selectedAgenda.agendaText = value;
    }

    async getDocuments() {
        if (!this.selectedCommittee) this.documents = [];
        else this.documents = await this.uow.getCommitteeDocuments(this.memberCode, this.selectedCommittee.CommitteeId);
    }

    async rename() {
        const modalRef = this.modalService.show(AttachmentDialogComponent, {
            class: 'modal-md',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                fileUploaded: true,
                attachment: this.dataGrid.instance.getSelectedRowsData()[0],
                renameOnly: true,
            },
        });
        modalRef.content.result.subscribe(async (result) => {
            if (result.success) {
            } else {
                this.uow.rollback();
            }
            modalRef.hide();
        });
    }

    async editCommitteeAttachment() {
        // if (!this.selectedAgenda) return;
        // const name = await this.getInput(`Enter Name`, 'text', null, this.selectedAgenda.name);
        // if (!name) return;
        // this.selectedAgenda.name = name;
        // await this.uow.commit();
        // await this.getData();
    }

    async deleteDocument() {
        const selectedRows = this.dataGrid.instance.getSelectedRowsData();
        if (!selectedRows) return;
        const result = await confirm(`Are you sure you want to delete?`, `GRRAFSCHAP`);
        if (!result) return;
        this.appInfo.pleaseWaitShow();
        selectedRows.forEach((x) => {
            x.deleted = new Date();
            x.deletedBy = this.userName;
        });
        await this.uow.commit();
        await this.getDocuments();
        this.appInfo.pleaseWaitHide();
    }

    async save() {
        this.appInfo.pleaseWaitShow();
        await this.uow.commit();
        this.appInfo.pleaseWaitHide();
    }
    cancel() {
        this.suppressValueChange = true;
        this.uow.rollback();
        setTimeout(() => {
            this.suppressValueChange = false;
        }, 0);
    }

    async onSelectionChanged(e) {
        // if (this.hasChanges() && !this.disableSelection) {
        //     this.disableSelection = true;
        //     const result = await confirm(`There are pending changes. Continue?  Yes to lose change, No to go back and save`, `${this.appInfo.settings.church}`);
        //     if (result) {
        //         this.uow.rollback();
        //     }
        //     if (!result) {
        //         this.dataGrid.instance.selectRows(e.currentDeselectedRowKeys, false);
        //         this.disableSelection = false;
        //         return;
        //     }
        // }
        // this.selectedAgenda = this.dataGrid.instance.getSelectedRowsData()[0];
        // this.canEmail = this.selectedAgenda && this.selectedAgenda.agendaText !== null;
    }

    onToolbarPreparing(e) {
        e.toolbarOptions.items.unshift(
            {
                template: 'toolbarText',
                location: 'before',
            },
            {
                template: 'toolbarButtons',
                location: 'before',
            },
            {
                widget: 'dxButton',
                options: {
                    icon: 'revert',
                    elementAttr: { title: 'Reset Filters' },
                    onClick: () => {
                        e.component.clearFilter();
                    },
                },
                location: 'after',
            },
        );
    }

    rowDoubleClick(e) {
        console.log(e);
        this.openAttachment(e.data);
    }

    attachmentDoubleClick(e) {
        this.openAttachment(e.data);
    }

    openAttachment(attachment: CommitteeAttachment) {
        if (!attachment) return;
        window.open(attachment.filename, '_blank');
    }

    rowPrepare(e) {
        if (e.rowType === 'data') {
            if (!e.data.approved && !e.data.declined) {
                e.rowElement.className = e.rowElement.className + ' waiting-for-vote';
            }
        }
    }

    async add(selectedRow?: any) {
        if (this.hasChanges()) {
            await alert(`Save changes first`, `Graafschap CRC`);
            return;
        }

        const modalRef = this.modalService.show(AttachmentDialogComponent, {
            class: 'modal-md',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                committeeId: this.selectedCommittee.CommitteeId,
            },
        });
        modalRef.content.result.subscribe(async (result) => {
            if (result.success) {
                await this.getDocuments();
            }
            if (!result.success) this.uow.rollback();
            modalRef.hide();
        });
    }

    async print() {
        const selectedRow = this.agendaDataGrid.instance.getSelectedRowsData()[0];
        if (!selectedRow) return;
        await this.utility.printAgenda(selectedRow.id);
    }

    async email(mode?: string) {
        const selectedRow = this.agendaDataGrid.instance.getSelectedRowsData()[0];
        if (!selectedRow) return;

        if (this.hasChanges()) return;

        const members = await this.uow.getMembersByCommitteeId(this.selectedCommittee.CommitteeId);

        const emailMessage = this.uow.committeeAttachmentEmails.createEntity({
            committeeId: this.selectedCommittee.CommitteeId,
            created: new Date(),
            createdBy: this.userName,
        });

        const modalRef = this.modalService.show(EmailDialogComponent, {
            class: 'modal-lgw',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                entity: selectedRow,
                emailMessage: emailMessage,
                selectedCommitteeId: this.selectedCommittee.CommitteeId,
                members: members,
                subject: `Graafschap Documents`,
                body: `Please see the attached file(s).`,
                mode:
                    this.selectedCommittee.CommitteeId === Committee.Committees.ExecutiveCommittee
                        ? 'executive'
                        : this.selectedCommittee.CommitteeId === Committee.Committees.Finance
                          ? 'finance'
                          : null,
            },
        });
        modalRef.content.result.subscribe(async (result) => {
            if (!!result && result.value) {
                this.appInfo.pleaseWaitShow();
                await this.uow.commit();
                await this.utility.emailAgendaDocumentPackage(selectedRow.id, emailMessage.id, result.memberIds);
                this.appInfo.pleaseWaitHide();
                const status = alert(`Email Sent!`, `${this.appInfo.settings.church.toUpperCase()}`);
            } else if (!result) this.uow.rollback();
            modalRef.hide();
            this.processing = false;
            await this.getData();
        });
    }

    async uploadStarted(e) {
        // this.appInfo.pleaseWaitShow();
    }

    async uploaded(e) {
        if (e && e.request && e.request.responseText) {
            const fileResponses = JSON.parse(e.request.responseText);
            for (let idx = 0; idx < fileResponses.length; idx++) {
                const fileResponse = fileResponses[idx];
                // const attachment = this.uow.attachments.createEntity({
                //     bidId: this.bid.id,
                //     name: fileResponse.name,
                //     filename: fileResponse.filename,
                //     created: new Date(),
                //     createdBy: this.userName,
                // }) as Attachment;
                // this.bidAttachments.push(attachment);
            }
        }
        // await this.uow.commit();
        // await this.getData();
        // this.appInfo.pleaseWaitHide();
    }

    async uploadError(e) {
        // await alert('An error occurred while attempting to upload the file(s)', `${this.appInfo.settings.church}`);
        // this.appInfo.pleaseWaitHide();
    }

    async getInput(prompt: string, mode: string, array?: any[], value?: any): Promise<any> {
        let modalRef = this.modalService.show(InputDialogComponent, {
            class: 'modal-sm',
            ignoreBackdropClick: true,
            keyboard: false,
            initialState: {
                dialogHeader: 'Graafschap Church',
                dialogPrompt: prompt,
                dialogValueArray: array,
                dialogValue: value,
                mode: mode,
            },
        });
        const promise = new Promise<any>(async (resolve, reject) => {
            modalRef.content.result.subscribe(async (result) => {
                if (result.success) {
                    resolve(result.value);
                }
                modalRef.hide();
                resolve(null);
            });
        });
        return promise;
    }
}
